/* ========================================================================
   Icon blocks
 ========================================================================== */

app.iconBlocks = (function () {
  'use strict';

  function init() {
    const sections = document.querySelectorAll('.js-iconBlocksSlider');
    if (sections.length === 0) return;

    sections.forEach((section) => {
      const viewport = section.querySelector('.iconBlocks__viewport');
      const items = viewport.querySelectorAll('.iconBlocks__item');

      const slider = new EmblaCarousel(viewport, {
        inViewThreshold: 0.1,
        align: 'start',
        containScroll: 'trimSnaps',
      });

      slider.on('init', (event) => {
        viewport.classList.add('is-initialized');
      });

      items.forEach((item, index) => {
        item.addEventListener('focus', (event) => {
          item.scrollIntoView();
        });
      });
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
